import { mapGetters, mapActions } from 'vuex'
import { sign } from '@/utils/sign'
import { redirectUrl } from '@/utils'

export default {
  data() {
    return {
      username: '',
      password: '',
    }
  },
  computed: {
    ...mapGetters(['isShowLogin']),
  },
  methods: {
    ...mapActions({
      signin: 'USER_SIGN_IN',
      wxSignin: 'WX_SIGN_IN',
      toggleLogin: 'TOGGLE_LOGIN',
    }),
    switchSignUp() {
      redirectUrl(window.$global.UserUrl)
    },
    findPassword() {
      redirectUrl(window.$global.FindPwdUrl)
    },
    handleLogin() {
      const { signature, noncestr, timestamp } = sign('VgoUser')

      const options = {
        username: this.username,
        password: this.password,
        signature: signature,
        timestamp: timestamp,
        nonce: noncestr,
      }

      this.signin(options)
    },
  },
}
